import React, { ReactElement } from 'react';
import { TerminDetail } from 'tezaury-frontend-ts-axios';
import './detailTerminu.scss';
import DetailTerminuActions from './DetailTerminuActions/DetailTerminuActions';
import DetailTerminuZakladneUdaje from './DetailTerminuZakladneUdaje/DetailTerminuZakladneUdaje';
import DetailTerminuDefinicie from './DetailTerminuDefinicie/DetailTerminuDefinicie';
import DetailTerminuJudikatyARozdeleniaSudov
  from './DetailTerminuJudikatyARozdeleniaSudov/DetailTerminuJudikatyARozdeleniaSudov';
import DetailTerminuPouzitiePredpis
  from './DetailTerminuPouzitiePredpis/DetailTerminuPouzitiePredpis';
import DetailTerminuPreviazaneTerminy
  from './DetailTerminuPreviazaneTerminy/DetailTerminuPreviazaneTerminy';
import DetailTerminuPoznamka from './DetailTerminuPoznamka/DetailTerminuPoznamka';

interface Props {
  termin: TerminDetail;
  admin?: boolean;
  reloadTermin,
}

const DetailTerminu = ({ termin, admin = false, reloadTermin } : Props): ReactElement => (
  <div className="pre-wrap">
    <DetailTerminuActions termin={termin} admin={admin} reloadTermin={reloadTermin} />

    <DetailTerminuZakladneUdaje termin={termin} admin={admin} />

    <DetailTerminuDefinicie termin={termin} admin={admin} />

    <DetailTerminuJudikatyARozdeleniaSudov termin={termin} admin={admin} />

    <DetailTerminuPouzitiePredpis termin={termin} admin={admin} />

    <DetailTerminuPreviazaneTerminy termin={termin} admin={admin} />

    <DetailTerminuPoznamka termin={termin} admin={admin} />
  </div>
);
export default DetailTerminu;
